module.exports = __webpack_public_path__ + "static/media/view-investor-report.31590031.svg";